import script from "./Adminview.vue?vue&type=script&setup=true&lang=js"
export * from "./Adminview.vue?vue&type=script&setup=true&lang=js"

import "./Adminview.vue?vue&type=style&index=0&id=05eea363&scoped=true&lang=css"
import "./Adminview.vue?vue&type=style&index=1&id=05eea363&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05eea363"]])

export default __exports__